import React, { useEffect } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export default function Lightbox({ images, currentIndex, onClose, onPrev, onNext }) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") onPrev();
      if (e.key === "ArrowRight") onNext();
    };
    window.addEventListener("keydown", handleKeyDown);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "unset";
    };
  }, [onClose, onPrev, onNext]);

  if (currentIndex === null || currentIndex === undefined) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4 backdrop-blur-sm select-none">
      {/* Close button */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-white hover:text-[#00D492] transition-colors p-2 rounded-full bg-black/50 hover:bg-black/80 cursor-pointer"
        aria-label="Luk"
      >
        <X className="w-8 h-8" />
      </button>

      {/* Navigation buttons */}
      {images.length > 1 && (
        <>
          <button
            onClick={(e) => {
              e.stopPropagation();
              onPrev();
            }}
            className="absolute left-4 text-white hover:text-[#00D492] transition-colors p-3 rounded-full bg-black/50 hover:bg-black/80 cursor-pointer"
            aria-label="Forrige"
          >
            <ChevronLeft className="w-8 h-8" />
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              onNext();
            }}
            className="absolute right-4 text-white hover:text-[#00D492] transition-colors p-3 rounded-full bg-black/50 hover:bg-black/80 cursor-pointer"
            aria-label="Næste"
          >
            <ChevronRight className="w-8 h-8" />
          </button>
        </>
      )}

      {/* Image container */}
      <div className="max-w-4xl max-h-[85vh] flex flex-col items-center justify-center" onClick={onClose}>
        <img
          src={images[currentIndex]}
          alt={`Billede ${currentIndex + 1}`}
          className="max-w-full max-h-[80vh] object-contain rounded-lg shadow-2xl"
          onClick={(e) => e.stopPropagation()}
        />
        <div className="text-white/80 text-sm mt-4 font-medium">
          {currentIndex + 1} af {images.length}
        </div>
      </div>
    </div>
  );
}
